"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_blog(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "80ccb0cc-d6cd-4e84-8e55-c8647ae3330a",
    x1: 93.37,
    y1: 98.62,
    x2: 152.67,
    y2: 157.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("title", null, "blog-hi"), /*#__PURE__*/React.createElement("g", {
    id: "a189a56e-313c-4159-8be4-2f5160660f6c",
    "data-name": "blog-hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "24cf5ffa-bb44-461a-adbf-d50793324981",
    "data-name": "Cloud_upload_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "61e51a66-052f-48e2-aca2-4f4833255a6d",
    "data-name": "Calls_Contacts_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "da69c597-a235-4eb8-ad6d-cb10e7e44606",
    "data-name": "PayG_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "92a48b68-0b5c-4e78-89b3-5b61e00a6ac8",
    "data-name": "Mobile_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "8a9546ac-13bd-4dbf-86a9-d0e080162352",
    "data-name": "My_Vodafone_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "24658b6c-fb50-4fff-af83-eaa64b575083",
    "data-name": "Settings_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a72d8364-25f6-4800-82cf-5955671734f3",
    "data-name": "User_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "03263cb9-9b00-46f8-bd7b-ad8b1a0bccdb",
    "data-name": "Video_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "16de5e59-e601-4432-9dd2-196e62a55e54",
    "data-name": "Tutorials_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "14bd4ff3-e124-4fcd-a516-c5ed0c3c3644",
    "data-name": "Community_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "7ce50e75-fec6-4df7-9490-285e2c5b95e0",
    "data-name": "Entertainment_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ca959754-e90a-4f19-a41f-5330974b368c",
    "data-name": "Insurance_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d76ebb1e-2dac-4fdb-94c6-c7e57f27109c",
    "data-name": "Photos_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "120517cf-ccf4-4968-9d16-20aa12b21777",
    "data-name": "Pie_chart_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e921824e-6c9c-4164-b85f-5c9aa0a809b8",
    "data-name": "Shopping_trolley_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "605e66a8-c8ad-4dc4-b863-4a686497b929",
    "data-name": "Business_phone_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "247c74ee-e554-4e0f-a243-88812b35bcbf",
    "data-name": "Bundles_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "61fb7b5a-b13c-4488-b440-10d198c6dcb3",
    "data-name": "Customer_care_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f372f47f-cc4a-445a-aec7-83771d810e07",
    "data-name": "Minutes_sms_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4579e33b-ae3b-418e-a916-f7ef089915b6",
    "data-name": "Bar_chart_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e8a7dcd7-538c-4ca3-ba71-7792e5f3f15a",
    "data-name": "Line_chart_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1b57b209-41aa-4347-baf5-8197c68de2c2",
    "data-name": "Blog_ic_hi"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 40,
    width: 128,
    height: 128,
    rx: 16,
    ry: 16,
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136,166H40a16,16,0,0,1-16-16v2a16,16,0,0,0,16,16h96a16,16,0,0,0,16-16v-2A16,16,0,0,1,136,166Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152,64.5h0l-70.5,70L47,145l23,23h66a16,16,0,0,0,16-16Z",
    transform: "translate(0 0)",
    opacity: 0.2,
    fill: "url(#80ccb0cc-d6cd-4e84-8e55-c8647ae3330a)"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "81.93 134.46 74.14 137.07 73.24 137.37 66.03 139.78 61.07 141.44 54.9 143.51 52.8 141.41 50.7 139.31 48.6 137.21 50.67 131.04 52.33 126.09 54.74 118.87 55.05 117.97 57.65 110.18 64.94 102.9 89.22 127.19 81.93 134.46",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171,21.11a17.17,17.17,0,0,0-24.28,0l-8.16,8.16,24.28,24.28L171,45.38A17.17,17.17,0,0,0,171,21.11Z",
    transform: "translate(0 0)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.29,
    y: 25.66,
    width: 4,
    height: 34.33,
    transform: "translate(13.45 118.11) rotate(-45)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.29,
    y: 25.66,
    width: 4,
    height: 34.33,
    transform: "translate(13.45 118.11) rotate(-45)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "81.93 134.46 74.14 137.07 73.24 137.37 66.03 139.78 61.07 141.44 54.9 143.51 52.8 141.41 50.7 139.31 48.6 137.21 50.67 131.04 52.33 126.09 54.74 118.87 55.05 117.97 57.65 110.18 64.94 102.9 89.22 127.19 81.93 134.46",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.87,133.42l-3.14,9.37a2,2,0,0,0,2.58,2.58l9.4-3.15Z",
    transform: "translate(0 0)",
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58,110.51l-.15-.15A.24.24,0,0,0,58,110.51Z",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.86,134.39l-.35-.35C81.45,134.5,81.65,134.5,81.86,134.39Z",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.82,40.18,73.14,110.86l-7.39,7.39a1.08,1.08,0,0,0,1,.3,5.72,5.72,0,0,1,6.79,6.79,1.08,1.08,0,0,0,.27,1l7.39-7.39,70.68-70.68Z",
    transform: "translate(0 0)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.82,40.18,73.14,110.86l-7.39,7.39a1.08,1.08,0,0,0,1,.3,5.72,5.72,0,0,1,6.79,6.79,1.08,1.08,0,0,0,.27,1l7.39-7.39,70.68-70.68Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.74,32.1,57.65,110.18l.18.18.15.15a.77.77,0,0,0,.37,0,5.72,5.72,0,0,1,7.12,6.71,1.08,1.08,0,0,0,.27,1l7.39-7.39,70.68-70.68Z",
    transform: "translate(0 0)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.89,48.25,81.21,118.93l-7.39,7.39a1.08,1.08,0,0,0,1,.31,5.72,5.72,0,0,1,6.71,7.12,1.94,1.94,0,0,0,0,.28l.35.35.07.07L160,56.37Z",
    transform: "translate(0 0)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.89,48.25,81.21,118.93l-7.39,7.39a1.08,1.08,0,0,0,1,.31,5.72,5.72,0,0,1,6.71,7.12,1.94,1.94,0,0,0,0,.28l.35.35.07.07L160,56.37Z",
    transform: "translate(0 0)",
    opacity: 0.12
  })))))))))))))))))))))))));
}

var _default = ic_blog;
exports.default = _default;